import { render, staticRenderFns } from "./viewList.vue?vue&type=template&id=1a18516c&scoped=true"
import script from "./viewList.vue?vue&type=script&lang=js"
export * from "./viewList.vue?vue&type=script&lang=js"
import style0 from "./viewList.vue?vue&type=style&index=0&id=1a18516c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a18516c",
  null
  
)

export default component.exports